<template>
    <div>
        <st-data-table
            :items="rows"
            :fields="fields"
            :actions="actions"
            :modelPresenter="presenter"
            :loading="isLoading"
            @edit="onEdit"
            @view="onView"
            @delete="onDelete"
            responsive="sm"
            hover
        >
        </st-data-table>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { UrbanismRegulationZonesModel } from '@/modules/administrator/models/urbanism-regulation-zones-model';

    const { fields } = UrbanismRegulationZonesModel;

    export default {
        name: 'UrbanismRegulationsListTable',
        data() {
            return {
                presenter: UrbanismRegulationZonesModel.presenter,
                actions: [
                    {
                        name: 'view',
                        icon: 'eye',
                        tooltipText: this.$t('GENERAL.ACTIONS.VIEW'),
                        customIcon: false,
                        type: 'primary'
                    },
                    {
                        name: 'edit',
                        icon: 'edit',
                        tooltipText: this.$t('GENERAL.ACTIONS.EDIT'),
                        customIcon: false,
                        type: 'primary'
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                        tooltipText: this.$t('GENERAL.ACTIONS.DELETE'),
                        customIcon: false,
                        type: 'primary'
                    }
                ],
            };
        },
        computed: {
            ...mapGetters({
                rows: 'administrator/urbanismRegulationZonesList/rows',
                loading: 'shared/loading',
            }),
            fields() {
                return [
                    fields.name,
                    fields.key,
                    fields.type,
                    fields.tenant_name,
                ]
            },
            isLoading () {
                return this.loading['urbanismRegulations/get'] ;
            },
        },
        methods: {
            ...mapActions({
                selectRecord: 'administrator/urbanismRegulationZonesForm/select',
                deleteRecord: 'administrator/urbanismRegulationZonesForm/remove',
            }),
            async onEdit(data) {
                await this.selectRecord(data.item);
                this.$emit('edit', data);
            },
            async onDelete(data) {
                await this.deleteRecord(data.item.id);
                this.$emit('update');
            },
            async onView(data) {
                await this.selectRecord(data.item);
                this.$emit('manage', data);
            }
        },
    };
</script>
